import request from './api';
import {
  API_PAYROLL,
  API_PAYROLL_INCIDENCE,
  API_INBOX_INCIDENCE
} from '../constants/api';

export const getLatestPayrollList = (
  fromDate = '',
  toDate = '',
  maxResults = 5
) =>
  request(`${API_PAYROLL}/list`, {
    method: 'GET',
    params: { fromDate, toDate, maxResults }
  });

export const getDatesWithPayrolls = employeeId =>
  request(`${API_PAYROLL}/months`, {
    method: 'GET',
    params: { employeeId }
  });

export const getPayrollFile = (
  payslipDate,
  allocationDate,
  entryDate,
  payslipType = 'PAYMENT',
  token,
  managedUserId,
  nif
) =>
  request(
    API_PAYROLL,
    {
      method: 'GET',
      responseType: 'blob',
      params: {
        payslipDate,
        allocationDate,
        entryDate,
        payslipType,
        token,
        managedUserId,
        nif
      }
    },
    false
  );

export const getPayrollsListWithSensitiveData = (
  yearMonth,
  token,
  managedUserId,
  nif
) =>
  request(`${API_PAYROLL}/month`, {
    method: 'GET',
    params: { yearMonth, token, managedUserId, nif }
  });

export const postPayrollIncidence = (matter, incidence) =>
  request(`${API_PAYROLL_INCIDENCE}?subject=${matter}&issure=${incidence}`, {
    method: 'POST'
  });

export const postInboxIncidence = (matter, incidence) =>
  request(`${API_INBOX_INCIDENCE}?subject=${matter}&issure=${incidence}`, {
    method: 'POST'
  });
